import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { IoMdAddCircle } from "react-icons/io";
import { RiSendPlaneFill } from "react-icons/ri";
import EmailLog from "./email/EmailLog";
import EmailTemplateList from "./email/EmailTemplateList";

export default function EmailSettings() {
  return (
    <>
      <div className="container-fluid mx-3 mt-4 d-flex justify-content-between">
        <div className="row">
          <div className="col-12">
            <div className="pageTitle">
              <h1>Email</h1>
            </div>
          </div>
        </div>
        <div className="row align-right">
          <div className="col-12">
            <ul className="d-flex justify-content-center">
              <li className="mx-2">
                <a className="btn btn-primary">
                  {" "}
                  <RiSendPlaneFill />
                </a>
              </li>
              <li className="btn btn-primary mx-2">
                {" "}
                {/* <AddCustomer type="add" /> */}
                <IoMdAddCircle />
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="container d-flex justify-content-between mt-5">
        <div className="row">
          <div className="col-12">
            <div className="pageTitle">
              <h1>Email</h1>
            </div>
          </div>
        </div>
      </div> */}
      <div className="container">
        <Tabs
          defaultActiveKey="email-logs"
          id="fill-tab-example"
          className="addBusiness-tab mb-3"
          fill
        >
          <Tab eventKey="email-logs" title="Email Logs">
            <EmailLog />
          </Tab>
          <Tab eventKey="templates" title="Email Templates">
            <EmailTemplateList />
          </Tab>
          {/* <Tab eventKey="setting" title="Email Setting">
            Tab content for Loooonger Tab
          </Tab> */}
        </Tabs>
      </div>
    </>
  );
}
